export default {
  deliveryDates: [],
  deliveryDate: undefined,
};
